import { Link } from "react-router-dom";
import { Check } from "lucide-react";
import { waLink, WA_CARGO_MSG } from "@/lib/site";
import BoardTransferForm from "@/components/site/BoardTransferForm";

const ROUTES = [
  {
    title: "Medan (KNO) → Raffiel Nias",
    desc: "Cargo collection at airport or transit hub, delivered safely to our hotel storage.",
    price: "IDR 1,300,000 / board bag",
  },
  {
    title: "Padang (PDG) → Raffiel Nias",
    desc: "Secure ferry and overland forwarding for single boards or multi-quiver coffins.",
    price: "IDR 1,600,000 / board bag",
  },
];

export const BoardTransferIntro = ({ showPageLink = false }) => (
  <div className="lg:col-span-5">
    <span className="text-xs font-mono-clean text-terracotta uppercase tracking-wider font-semibold">
      Save Airport Baggage Overcharges
    </span>
    <h2 className="font-display text-3xl sm:text-4xl font-bold mt-2 text-white leading-tight">
      Board bag cargo transfer from Medan & Padang.
    </h2>
    <p className="text-sm text-sand-50/80 mt-4 leading-relaxed">
      Airlines charging exorbitant rates for surfboards from Medan (KNO) or
      Padang (PDG) to Binaka Airport Nias (GNS)? We arrange reliable overland
      and ferry cargo forwarding directly to Raffiel Nias hotel reception
      before your session begins.
    </p>
    <div className="mt-8 space-y-4">
      {ROUTES.map((r) => (
        <div key={r.title} className="flex items-start gap-4 p-4 rounded-xl bg-white/5 border border-white/10">
          <div className="w-8 h-8 rounded-full bg-ocean-700 flex items-center justify-center shrink-0">
            <Check size={14} className="text-white" />
          </div>
          <div>
            <h4 className="text-sm font-semibold text-white">{r.title}</h4>
            <p className="text-xs text-sand-50/70 mt-1">{r.desc}</p>
            <p className="text-xs font-mono-clean font-semibold text-terracotta mt-2" data-testid={`route-price-${r.title.includes("Medan") ? "medan" : "padang"}`}>
              {r.price}
            </p>
          </div>
        </div>
      ))}
    </div>
    <div className="mt-8 flex flex-wrap items-center gap-3">
      <a
        href={waLink(WA_CARGO_MSG)}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="board-transfer-whatsapp-button"
        className="inline-flex items-center justify-center px-5 py-3 rounded-xl bg-terracotta text-white text-xs font-semibold uppercase tracking-wider hover:bg-terracotta-light transition-colors"
      >
        Quick WhatsApp Cargo Chat
      </a>
      {showPageLink && (
        <Link
          to="/board-transfer"
          data-testid="board-transfer-page-link"
          className="inline-flex items-center justify-center px-5 py-3 rounded-xl bg-white/10 border border-white/20 text-white text-xs font-semibold uppercase tracking-wider hover:bg-white/20 transition-colors"
        >
          How It Works
        </Link>
      )}
    </div>
  </div>
);

const BoardTransferSection = () => (
  <section id="board-transfer" className="py-24 bg-ocean-900 text-white" data-testid="board-transfer-section">
    <div className="max-w-7xl mx-auto px-6">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-start">
        <BoardTransferIntro showPageLink />
        <div className="lg:col-span-7">
          <BoardTransferForm />
        </div>
      </div>
    </div>
  </section>
);

export default BoardTransferSection;
